import { LegalLayout } from './LegalLayout';

/**
 * Phase 15.6 — Beta-Datenschutzerklärung mit Platzhalter-Warnung. Vor dem
 * Public-Launch muss dieses Dokument mit echten Adressdaten + AV-Verträgen
 * gemäß Art. 13/14 DSGVO finalisiert werden.
 */
export default function Privacy() {
  return (
    <LegalLayout title="Datenschutzerklärung">
      {__IS_BETA__ && (
        <div className="rounded-md border border-amber-500/40 bg-amber-500/10 p-4 text-sm text-amber-100">
          ⚠️ <strong>Platzhalter-Datenschutzerklärung.</strong> Bitte vor Beta-Launch
          vollständig ausfüllen!
        </div>
      )}

      <div className="mt-6 space-y-6 text-sm leading-relaxed text-fg-secondary">
        <p>Diese Datenschutzerklärung gilt für die Closed Beta von Dispatch24.</p>

        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">
            1. Verantwortlicher
          </h2>
          <p>[Vollständige Adresse wie Impressum]</p>
        </section>

        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">
            2. Datenverarbeitung
          </h2>

          <p className="mt-3 font-semibold text-fg-primary">a) Spielstand</p>
          <p>
            Dein Spielstand wird ausschließlich lokal in deinem Browser (
            <code className="rounded bg-bg-elevated px-1.5 py-0.5 text-xs">localStorage</code>)
            gespeichert. Es findet keine Übertragung an unsere Server statt. Wenn du deinen
            Browser-Cache löschst, ist dein Spielstand verloren.
          </p>

          <p className="mt-3 font-semibold text-fg-primary">b) Beta-Zugang</p>
          <p>
            Für den Zugang zur Closed Beta nutzen wir Cloudflare Access. Deine Email-Adresse wird
            zur Identifizierung als Beta-Tester verwendet. Cloudflare ist hierbei
            Auftragsverarbeiter.
          </p>

          <p className="mt-3 font-semibold text-fg-primary">c) Bug-Reports und Fehler-Logs</p>
          <p>
            Wenn du einen Bug meldest oder ein Fehler im Spiel auftritt, senden wir folgende
            Daten an unsere Server (Cloudflare KV):
          </p>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            <li>Dein Tester-Pseudonym (selbst gewählt oder zufällig)</li>
            <li>Beschreibung des Bugs (deine Eingabe)</li>
            <li>Aktueller Spielstand-Snapshot (komprimiert, ohne persönliche Daten)</li>
            <li>Letzte 50 Log-Einträge des Browsers</li>
            <li>Browser-User-Agent und Bildschirmgröße</li>
            <li>Spielversion + Git-Hash</li>
          </ul>
          <p className="mt-2">
            Diese Daten werden 30 Tage gespeichert und ausschließlich zur Bug-Analyse verwendet.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">
            3. Drittanbieter
          </h2>
          <ul className="list-disc space-y-1 pl-5">
            <li>Cloudflare Inc., USA: Hosting, Access-Control, Log-Speicher</li>
            <li>OpenStreetMap Foundation, UK: Karten-Daten</li>
            <li>Nominatim (OSM): Stadtsuche</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">
            4. Deine Rechte
          </h2>
          <p>
            Du hast das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der
            Verarbeitung deiner Daten. Kontaktiere uns hierfür unter [EMAIL].
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display text-base font-semibold text-fg-primary">
            5. Speicherdauer
          </h2>
          <p>
            Bug-Reports und Fehler-Logs: 30 Tage automatische Löschung.
            <br />
            Beta-Zugang: bis Beta-Ende oder Widerruf.
          </p>
        </section>

        <p className="text-xs text-fg-muted">Stand: [DATUM]</p>
      </div>
    </LegalLayout>
  );
}
